import { LOCAL_STORAGE_KEYS } from '@/constants/localStorageKeys';

interface VideoPlayerVolume {
  muted: boolean;
  volume: number;
}

export const getVideoPlayerVolume = (): VideoPlayerVolume | null => {
  if (typeof window !== 'undefined') {
    const item = localStorage.getItem(LOCAL_STORAGE_KEYS.videoPlayerVolume);

    if (item) {
      try {
        return JSON.parse(item) as VideoPlayerVolume;
      } catch {
        console.warn('Error reading video player volume');
      }
    }
  }

  return null;
};
